<div class="label-subject" [attr.data-subject-type]="subjectLabelStyle">
  <span>{{ subjectLabelName }}</span>
</div>
